//Style partagé pour les selects
export const FIELD_DIMENSIONS = {
  height: "26px",
  minHeight: "26px",
  fontSize: "0.75rem",
  padding: "4px 6px",
  borderRadius: "4px",
  borderWidth: "1px",
};


export const makeSelectStyles = (layout) => (hasError) => ({
  container: (provided) => ({
    ...provided,
    overflow: "visible",
    fontSize: "0.7109375rem",
  }),
  menu: (provided) => ({
    ...provided,
    textAlign: "left",
    overflow: "visible",
    backgroundColor: layout === "dark" ? "#2A3042" : "#fff",
    color: layout === "dark" ? "#fff" : "#000",
    marginTop: "-8px",
    marginBottom: "0px",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#ebd826"
      : layout === "dark"
      ? "#444"
      : "#fff",
    color: state.isSelected ? "#212529" : layout === "dark" ? "#fff" : "black",
    textAlign: "left",
    fontWeight: "normal",
    paddingLeft: 40,
    paddingTop: 10,
  }),
  groupHeading: (provided) => ({
    ...provided,
    fontWeight: "bold",
    fontSize: "15px",
    color: layout === "dark" ? "white" : "black",
    textAlign: "left",
  }),
  control: (provided, state) => ({
    ...provided,
    minHeight: "1.69125rem",
    border: state.isFocused
      ? hasError
        ? "1px solid red"
        : layout === "dark"
        ? "1px solid #555"
        : "1px solid #ccc"
      : hasError
      ? "1px solid red"
      : layout === "dark"
      ? "1px solid #555"
      : "1px solid #ccc",
    backgroundColor: layout === "dark" ? "#2A3042" : "#fff",
    boxShadow: "none",
    "&:hover": {
      border: hasError
        ? "1px solid red"
        : layout === "dark"
        ? "1px solid #555"
        : "1px solid #ccc",
    },
  }),
  dropdownIndicator: (base) => ({ ...base, padding: "2px" }),
  clearIndicator: (base) => ({ ...base, padding: "2px" }),
});


export const makeStyleSelect = (dims, layout) => (isRequired) => ({
  control: (base, state) => ({
    ...base,
    height: dims.height,
    minHeight: dims.minHeight,
    borderRadius: dims.borderRadius,
    border: isRequired
      ? "1px solid #dc3545"
      : state.isFocused
      ? "1px solid #80bdff"
      : "1px solid white",
    boxShadow: state.isFocused
      ? isRequired
        ? "0 0 0 0.2rem rgba(220, 53, 69, 0.15)"
        : "0 0 0 0.2rem rgba(0, 123, 255, 0.15)"
      : "none",
    fontSize: dims.fontSize,
    transition: "all 0.15s ease-in-out",
    backgroundColor: "#fff",
    "&:hover": {
      borderColor: isRequired
        ? "#dc3545"
        : state.isFocused
        ? "#80bdff"
        : "#c6cdd4",
    },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: dims.padding,
    height: `calc(${dims.height} - 2px)`,
    display: "flex",
    alignItems: "center",
  }),
  input: (base) => ({
    ...base,
    margin: "0",
    padding: "0",
    fontSize: dims.fontSize,
  }),
  placeholder: (base) => ({
    ...base,
    fontSize: dims.fontSize,
    color: "#6c757d",
    opacity: 0.7,
  }),
  singleValue: (base) => ({
    ...base,
    fontSize: dims.fontSize,
    color: layout === "dark" ? "#fff" : "#212529",
  }),
  indicatorSeparator: () => ({ display: "none" }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "6px",
    color: "#6c757d",
    svg: { width: "13px", height: "13px" },
    "&:hover": { color: isRequired ? "#dc3545" : "#007bff" },
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: "2px",
    color: "#6c757d",
    svg: { width: "10px", height: "10px" },
    "&:hover": { color: "#dc3545" },
  }),
  menu: (base) => ({
    ...base,
    borderRadius: dims.borderRadius,
    border: "1px solid #e9ecef",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    fontSize: dims.fontSize,
    zIndex: "2147483647",
    marginTop: "-6px",
    marginBottom: "0px",
  }),
  option: (base, state) => ({
    ...base,
    zIndex: 2147483647,
    fontSize: dims.fontSize,
    padding: "6px 12px",
    backgroundColor: state.isSelected
      ? "#ebd826"
      : state.isFocused
      ? "#f8f9fa"
      : "white",
    color: state.isSelected ? "#212529" : layout === "dark" ? "#fff" : "#212529",
    "&:hover": {
      backgroundColor: state.isSelected
        ? isRequired
          ? "#dc3545"
          : "#007bff"
        : "#f8f9fa",
    },
  }),
});
